module.exports = __webpack_public_path__ + "img/tickcheck.41a1877d.svg";